module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABIAgMAAAB94riKAAAACVBMVEUAOJf////XKCjvr6buAAAAMElEQVR4AWOAgtBVq0IZUMAQlhmVGZUJhQCQDCqgsswqXGBoytAr3IZjShyVGZUBAJvrPChC77B4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/is.png
// module id = NfQn
// module chunks = 0